/* eslint-disable no-undef */
import { Swiper, Pagination, Autoplay, EffectFade } from 'swiper/dist/js/swiper.esm.js'

Swiper.use([Pagination, Autoplay, EffectFade])

jQuery(function ($) {
// initialize swiper when document ready
  const swiperElem = $('.swiper-container.references-swiper')
  if (swiperElem.length === 0) {
    return
  }
  let loopVal = false
  if ($(swiperElem).find('.swiper-slide').length > 1) {
    // loop only if swiper has more than 1 slide
    loopVal = true
  }

  const swiper = new Swiper(swiperElem, {
    fadeEffect: {
      crossFade: true
    },
    effect: 'fade',
    speed: 500,
    loop: loopVal,
    watchOverflow: true,
    autoHeight: false,
    centeredSlides: true,
    /* autoplay: {
      delay: 5000,
      disableOnInteraction: true
    }, */
    pagination: {
      el: $(swiperElem).find('.swiper-pagination'),
      clickable: true
    }
  })
})
